class FeaturedUpsellSection extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
  }

  connectedCallback() {
    this.initSwiper();
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }

  initSwiper() {
    const swiperEl = this.querySelector(".featured-upsell-section__swiper");
    const paginationEl = this.querySelector(
      ".featured-upsell-section__pagination"
    );

    if (!swiperEl || typeof Swiper === "undefined") return;

    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
    }

    this.swiperInstance = new Swiper(swiperEl, {
      slidesPerView: 2.2,
      spaceBetween: 12,
      pagination: {
        el: paginationEl,
        clickable: true,
        type: "progressbar",
      },
      breakpoints: {
        720: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
      },
    });
  }
}

if (!customElements.get("featured-upsell-section")) {
  customElements.define("featured-upsell-section", FeaturedUpsellSection);
}
